$(document).ready(function () {
  CategoryDropdown();

  $(window).resize(function () {
    CategoryDropdown();
  });

  if ($(".sp-articles-filter-form").length > 0) {
    var form = $(".sp-articles-filter-form");
    var url = form.data("url");

    form.find("input").change(function (e) {
      e.preventDefault();
      ajaxArticles(url, form);
    });

    $(document).on("click", ".sp-pagination a", function (e) {
      e.preventDefault();
      var url = $(this).attr("href");
      ajaxArticles(url, form);
    });
  }

  function ajaxArticles(url, form) {
    console.log(form.serialize());
    $.ajax({
      type: "GET",
      url: url,
      data: form.serialize(),
      success: function (response) {
        $(".sp-articles__wrapper").html(response);
        var newUrl = $(".sp-articles__all").data("url");
        history.pushState(null, null, newUrl);
      },
    });
  }

  /* 
		Small screen filtering:
		- add span for angle bracket
		- open/close filter lists 
	*/
  function CategoryDropdown() {
    if ($(".sp-articles-filter-form").length > 0 && $(window).width() < 1025) {
      var label = $(".sp-articles-filter-form .optionset label").first();
      var column = $(".sp-articles-filter-form .optionset .middleColumn");

      $(label).append('<span class="angle"></span>');

      $(label).on("click", function () {
        if ($(column).hasClass("open")) {
          $(column).removeClass("open");
        } else {
          $(column).addClass("open");
        }
      });

      $(column)
        .find("li label")
        .on("click", function () {
          $(column).removeClass("open");
        });
    }
  }
});
